import isEmpty from 'lodash/isEmpty';
import compact from 'lodash/compact';

export function buildGlobalFilterWhere({ name = null, email = null, description = null, actions = [], dateRange }) {
  const orClause = compact([
    buildNameTerm(name),
    buildEmailTerm(email),
    buildDescriptionTerm(description),
    buildActionsTerm(actions),
  ]);

  return {
    _and: [...(isEmpty(orClause) ? [] : [{ _or: orClause }]), buildDateRangeTerm(dateRange)],
  };
}

export function isGlobalFilterActive({ name, email, description, actions }) {
  return !isEmpty(name) || !isEmpty(email) || !isEmpty(description) || !isEmpty(actions);
}

function buildNameTerm(name) {
  return isEmpty(name) ? null : { userName: { _ilike: `%${name}%` } };
}

function buildEmailTerm(email) {
  return isEmpty(email) ? null : { userEmail: { _ilike: `%${email}%` } };
}

function buildDescriptionTerm(description) {
  return isEmpty(description) ? null : { description: { _ilike: `%${description}%` } };
}

function buildActionsTerm(actions) {
  return isEmpty(actions) ? null : { action: { _in: actions } };
}

function buildDateRangeTerm({ startDate, endDate }) {
  return { _and: [{ timestamp: { _gte: startDate } }, { timestamp: { _lt: endDate } }] };
}
